const configs = {
  dev: {
    agentid: '1000047',
    appid: 'ww80f80a93e563305f',
  },
  test: {
    agentid: '1000048',
    appid: 'ww80f80a93e563305f',
  },
  'test-large': {
    agentid: '1000042',
    appid: 'ww80f80a93e563305f',
  },
  preprod: {
    agentid: '1000054',
    appid: 'ww80f80a93e563305f',
  },
  'ides-large': {
    agentid: '1000072',
    appid: 'ww80f80a93e563305f',
  },
  uat: {
    agentid: '1000026',
    appid: 'ww80f80a93e563305f',
  },
  edu: {
    agentid: '1000025',
    appid: 'ww80f80a93e563305f',
  },
  hwprod: {
    agentid: '1000053',
    appid: 'ww80f80a93e563305f',
  },
}

const { SISYPHE_RUNTIME_ENV, PASSPORT_URL } = process.env

// const { } = window.location

const config = {
  ...configs[SISYPHE_RUNTIME_ENV],
  redirect_uri: `${PASSPORT_URL}/oauth`,
}

export default config
